<script>
import LifeStageData from '@/mixins/LifeStageData';
export default {
	mixins: [LifeStageData],
	data() {
		return {
			maxFinancialHealth: 10
		};
	},
	computed: {
		financialHealthPct() {
			return (
				(this.lifeStageData.studentSmileScoreData.score /
					this.maxFinancialHealth) *
				100
			);
		}
	}
};
</script>
